module.exports = __webpack_public_path__ + "img/41_12.bf3b10bd.png";